import React, { useState, useRef } from 'react';

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef({});

  const handleTitleClick = (index, e) => {
    e.preventDefault();
    
    const isCurrentlyActive = activeIndex === index;
    setActiveIndex(isCurrentlyActive ? null : index);

    // Smooth scroll
    if (e.target) {
      const element = e.target.closest('.tieudekhoi');
      if (element) {
        const topPosition = element.offsetTop;
        window.scrollTo({
          top: topPosition - 20, // Offset nhỏ để không dính sát top
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div className="accordion-container">
      {[1, 2, 3].map((item, index) => (
        <div key={index} className="khoi-item">
          <h3 
            className={`tieudekhoi ${activeIndex === index ? 'xanh' : ''}`}
            onClick={(e) => handleTitleClick(index, e)}
            style={{
              cursor: 'pointer',
              padding: '10px',
              border: '1px solid #ddd',
              margin: '5px 0',
              transition: 'all 0.3s ease'
            }}
          >
            Tiêu đề {item} {activeIndex === index ? '▼' : '►'}
          </h3>
          
          <div
            ref={el => contentRefs.current[index] = el}
            className="noidungkhoi"
            style={{
              maxHeight: activeIndex === index ? '500px' : '0',
              opacity: activeIndex === index ? 1 : 0,
              overflow: 'hidden',
              transition: 'all 0.5s ease-in-out',
              padding: activeIndex === index ? '15px' : '0 15px',
              border: activeIndex === index ? '1px solid #eee' : 'none'
            }}
          >
            <p>Nội dung chi tiết cho mục {item}</p>
            
            <div className="vaicaianh">
              {/* Thay thế fancybox bằng lightbox React */}
              <img 
                src="/path-to-image.jpg" 
                alt="Example" 
                style={{ maxWidth: '100%', cursor: 'pointer' }}
                onClick={() => {/* Xử lý mở lightbox */}}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;